<template>
  <div>
    <div class="mb-4">
      <div class="row">
        <div class="col-md-12 mb-3">
          <b-input-group>
            <b-input-group-text slot="prepend" class="bg-shade-1">
              <i class="fa fa-search"></i>
            </b-input-group-text>
            <b-input
              v-model="search"
              placeholder="Search by member name, university or research group"
              autocomplete="off"
              data-lpignore="true" />
          </b-input-group>
        </div>
      </div>
    </div>
    <line-loader v-if="loading" :size=2 />
    <div v-else-if="filteredList.length === 0">
      <span class="text-muted regular-14">No result</span>
    </div>
    <div v-else v-for="(member, index) in filteredList" :key="index">
      <b-card :class="index%2 === 1 ? 'bg-shade-2 mb-2' : 'bg-shade-1 mb-2'">
        <div class="row">
          <div class="col-md-2 order-md-1 my-auto">
            <div class="member-image mb-2 cursor-pointer" @click="peoplePage(member.person.id, 'link')">
              <img :src="fetchImage(member.person.profile_image, 400, 300)" onerror="this.src='/img/default-avatar-without-white.png'">
            </div>
          </div>
          <div class="col-md-4 my-auto">
            <span class="bold-21 cursor-pointer" @click="peoplePage(member.person.id, 'link')">
              {{member.person.first_name + ' ' + member.person.last_name}}
            </span>
            <div class="medium-16" v-if="member.person.home_institution">
              {{member.person.home_institution.name}}
            </div>
            <div v-if="member.person.member_roles.length > 0">
              <span
                v-for="(role, roleKey) in member.person.member_roles" 
                :key="roleKey"
                class="text-muted regular-16"
              >
                {{role}}<span v-if="roleKey < member.person.member_roles.length -1">,</span>
              </span>
            </div>
            <div class="mt-2 mb-2" v-if="member.sign_in_access">
              <a v-b-toggle="'collapse' + index" @click.prevent>
                <i
                  v-b-tooltip.hover ="'Show Details'"
                  class="fas fa-eye cursor-pointer typo-color-blue"
                >
                  <span class="regular-16 ml-1 mr-3">Show Details</span>
                </i>
              </a>
              <a :href="fetchLegacyUrl(`/programs/${member.program_id}/members/${member.member_id}/edit?redirect_url=${data.is_past ? 'past/programs' : 'programs'}`)">
                <i v-b-tooltip.hover ="'Edit'" class="fas fa-edit cursor-pointer custom-fa-edit-color typo-color-black">
                  <span class="regular-16 ml-1">Edit</span>
                </i>
              </a>
            </div>
          </div>
          <div class="col-md-6 my-auto">
            <visit-details-section :member="member" :visits="member.person.visits" :page-to="'programs'"/>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-12">
            <show-details-section :index="index" :show-details="member.person.show_details" />
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"
import VisitDetailsSection from "@/components/CommonPages/MemberDetailsSection/VisitDetailsSection.vue"
import ShowDetailsSection from "@/components/CommonPages/MemberDetailsSection/ShowDetailsSection.vue"
import LineLoader from "@/components/Loaders/LineLoader.vue"

export default {
	name: "ProgramMemberTab",
	components: { VisitDetailsSection, ShowDetailsSection, LineLoader },
	mixins: [mixin],
	props: ["data"],
	data() {
		return {
			search: "",
			programMembers: [],
			loading: true,
		}
	},
	computed: {
		filteredList: function () {
			const searchValue = this.search.toLowerCase()
			return this.programMembers.filter(
				(member) =>
					member.person &&
					((member.person.first_name !== null && member.person.first_name?.toLowerCase().indexOf(searchValue) !== -1) ||
						(member.person.last_name !== null && member.person.last_name?.toLowerCase().indexOf(searchValue) !== -1) ||
						(member.person.name !== null && member.person.name.toLowerCase().indexOf(searchValue) !== -1) ||
						(member.person.home_institution !== null &&
							member.person.home_institution.name !== undefined &&
							member.person.home_institution.name.toLowerCase().indexOf(searchValue) !== -1) ||
						(member.person.highest_degree_thesis !== null &&
							member.person.highest_degree_thesis.toLowerCase().indexOf(searchValue) !== -1)),
			)
		},
	},
	mounted() {
		this.loadProgramMemberDetails()
	},
	methods: {
		loadProgramMemberDetails() {
			this.loading = true
			this.$http.get(process.env.VUE_APP_API_URL + `/programs/${this.$route.params.id}/members`).then((res) => {
				this.programMembers = res.data.members
				this.loading = false
			})
		},
	},
}
</script>
